module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"enter-valid-number":"Bitte geben Sie eine gültige Nummer ein"},"fr":{"enter-valid-number":"Veuillez entrer un numéro valide"},"it":{"enter-valid-number":"Per favore, inserire un numero valido"}}')
  delete Component.options._Ctor
}
